/**
 * 速记模式工具函数
 * 提供速记模式所需的各种辅助函数
 */

/**
 * 获取今日笔记标题
 * 格式：年-月-日 建笔记
 * @returns 格式化的今日标题
 */
export const getTodayNoteTitle = (): string => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day} 建笔记`
}

/**
 * 计算笔记内容的纯文本字符数
 * 去除 HTML 标签和空格
 * @param content 笔记内容（JSON 格式或纯文本）
 * @returns 纯文本字符数
 */
export const calculateContentLength = (content: string): number => {
  if (!content || content.trim() === '') {
    return 0
  }

  try {
    // 尝试解析为 TipTap JSON 格式
    const parsed = JSON.parse(content)
    let text = ''

    const extractText = (node: any): void => {
      if (typeof node === 'string') {
        text += node
      } else if (node.text && typeof node.text === 'string') {
        text += node.text
      } else if (node.content && Array.isArray(node.content)) {
        node.content.forEach(extractText)
      }
    }

    extractText(parsed)
    // 去除所有空白字符后计算长度
    return text.replace(/\s/g, '').length
  } catch {
    // 如果不是 JSON 格式，按 HTML 或纯文本处理
    return content
      .replace(/<[^>]*>/g, '') // 去除 HTML 标签
      .replace(/\s/g, '')      // 去除空白字符
      .length
  }
}

/**
 * 检查笔记内容是否超过指定字符数
 * @param content 笔记内容
 * @param maxLength 最大字符数
 * @returns 是否超过
 */
export const isContentExceedLimit = (content: string, maxLength: number): boolean => {
  return calculateContentLength(content) > maxLength
}

/**
 * 获取笔记内容的摘要
 * @param content 笔记内容
 * @param maxLength 最大长度
 * @returns 摘要文本
 */
export const getContentSummary = (content: string, maxLength: number = 50): string => {
  const plainText = content
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim()

  if (plainText.length <= maxLength) {
    return plainText
  }

  return plainText.substring(0, maxLength) + '...'
}
